/**
 * This is a singleton to ensure we only instantiate Stripe once.
 */
import { loadStripe } from '@stripe/stripe-js';
import { STRIPE_PUBLISHABLE_TOKEN } from './stripe';

let stripePromise;
const getStripe = () => {
  if (!stripePromise) {
    stripePromise = loadStripe(STRIPE_PUBLISHABLE_TOKEN);
  }
  return stripePromise;
};

export default getStripe;
